// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"424":"a15ce062","544":"82026aed","787":"2185949b"}[chunkId] + ".chunk.js";
};